var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{key:_vm.name},[_c('TooltipTd',{attrs:{"variableName":_vm.name,"description":_vm.description,"deviceType":_vm.deviceType,"node":_vm.node}}),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.resolvedValue))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }